import { render, staticRenderFns } from "./TheCartOrderComment.vue?vue&type=template&id=35602a30&"
import script from "./TheCartOrderComment.vue?vue&type=script&lang=js&"
export * from "./TheCartOrderComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports